import React, { useEffect, useState } from "react";
import "./GymProfile.css";
import logo from "../../assets/dhanushdhari_final_log.jpeg";
import { useNavigate } from "react-router-dom";
import { Paymenthistory, ProfileUser } from "../../Services/Operations/ProductAPI";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../Store/authSlice";
import { toast } from "react-toastify";

const GymProfile = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("overview");
    const { isAuthenticated, token } = useSelector((state) => state.auth);
    const [user, setUser] = useState(null);
    const dispatch = useDispatch();

       const[history,setHistory]=useState([])

     const handleGetPayhistory=async()=>{
                try {
                    const res=await Paymenthistory(token)
                    console.log('Paymenthistory',res);
                    setHistory(res.data.data)
                    
                } catch (error) {
                    console.log(error);
                    
                }
            }
      

    const handleGetProfile = async () => {
        try {
            const res = await ProfileUser(token);
            console.log(res);
            setUser(res.data.data);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        handleGetProfile();
        handleGetPayhistory()
    }, []);

    const calculateAge = (birthDateString) => {
        const birthDate = new Date(birthDateString);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };

    const navItems = [
        { key: "overview",   label: "Overview",        icon: "⬡" },
        { key: "personal",   label: "Personal Info",   icon: "◈" },
        { key: "membership", label: "Membership",      icon: "◆" },
        { key: "workout",    label: "Workout History", icon: "◉" },
        { key: "payment",    label: "Payment History", icon: "◇" },
        { key: "settings",   label: "Settings",        icon: "◎" },
    ];

    const renderContent = () => {
        switch (activeTab) {

            case "overview":
                return (
                    <div className="content-card">
                        <div className="card-header">
                            <span className="card-tag">DASHBOARD</span>
                            <h2>Profile Overview</h2>
                            <p className="card-subtitle">Welcome back, <span className="accent-text">{user?.full_name}</span></p>
                        </div>

                        <div className="overview-grid">
                            <div className="overview-box">
                                <div className="overview-icon">◈</div>
                                <h3>Membership</h3>
                                <p>Premium Plan</p>
                            </div>
                            <div className="overview-box">
                                <div className="overview-icon">◉</div>
                                <h3>Trainer</h3>
                                <p>Rahul Sharma</p>
                            </div>
                            <div className="overview-box">
                                <div className="overview-icon">⬡</div>
                                <h3>Workouts</h3>
                                <p className="overview-stat">124</p>
                            </div>
                            <div className="overview-box">
                                <div className="overview-icon">◆</div>
                                <h3>Calories Burned</h3>
                                <p className="overview-stat">34,500 <span>kcal</span></p>
                            </div>
                        </div>
                    </div>
                );

            case "personal":
                return (
                    <div className="content-card">
                        <div className="card-header">
                            <span className="card-tag">ACCOUNT</span>
                            <h2>Personal Information</h2>
                        </div>
                        <div className="info-list">
                            <div className="info-row">
                                <span className="info-label">Full Name</span>
                                <p className="info-value">{user?.full_name}</p>
                            </div>
                            <div className="info-row">
                                <span className="info-label">Email</span>
                                <p className="info-value">{user?.email}</p>
                            </div>
                            <div className="info-row">
                                <span className="info-label">Phone</span>
                                <p className="info-value">+91 {user?.phone}</p>
                            </div>
                            <div className="info-row">
                                <span className="info-label">Age</span>
                                <p className="info-value">{calculateAge(user?.birth_date)} yrs</p>
                            </div>
                        </div>
                    </div>
                );

            case "membership":
                return (
                    <div className="content-card">
                        <div className="card-header">
                            <span className="card-tag">PLAN</span>
                            <h2>Membership</h2>
                        </div>
                        <div className="membership-box">
                            <div className="membership-badge">ACTIVE</div>
                            <h3>Premium Plan</h3>
                            <p className="membership-desc">Full access to all equipment & dedicated personal trainer</p>
                            <p className="membership-price">₹2,500<span>/mo</span></p>
                            <button className="upgrade-btn">Upgrade Plan</button>
                        </div>
                    </div>
                );

            case "workout":
                return (
                    <div className="content-card">
                        <div className="card-header">
                            <span className="card-tag">HISTORY</span>
                            <h2>Workout History</h2>
                        </div>
                        <table className="data-table">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Workout</th>
                                    <th>Duration</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>12 Mar</td>
                                    <td>Chest Workout</td>
                                    <td><span className="duration-pill">1 hr</span></td>
                                </tr>
                                <tr>
                                    <td>11 Mar</td>
                                    <td>Leg Workout</td>
                                    <td><span className="duration-pill">45 min</span></td>
                                </tr>
                                <tr>
                                    <td>10 Mar</td>
                                    <td>Cardio</td>
                                    <td><span className="duration-pill">30 min</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                );

            case "payment":
                // Replace this with real API data: user?.payment_history or similar
                const payments = user?.payment_history || [
                    { id: 1, package_name: "Basic Plan", duration: "1", admission_fee: "1000.00", package_price: "1500.00", total_amount: "2500.00", payment_type: "new",    date: "1 Mar 2026" },
                    { id: 2, package_name: "Basic Plan", duration: "1", admission_fee: "0.00",    package_price: "1500.00", total_amount: "1500.00", payment_type: "renewal", date: "1 Apr 2026" },
                    { id: 3, package_name: "Basic Plan", duration: "1", admission_fee: "0.00",    package_price: "1500.00", total_amount: "1500.00", payment_type: "renewal", date: "1 May 2026" },
                ];

                return (
                    <div className="content-card">
                        <div className="card-header">
                            <span className="card-tag">BILLING</span>
                            <h2>Payment History</h2>
                            <p className="card-subtitle">{payments.length} transaction{payments.length !== 1 ? "s" : ""} found</p>
                        </div>

                        <div className="payment-list">
                            {history.map((p, index) => (
                                <div
                                    className="payment-card"
                                    key={p.id ?? index}
                                    style={{ animationDelay: `${index * 0.07}s` }}
                                >
                                    <div className="payment-card-header">
                                        <div className="payment-card-plan">
                                            <span className="payment-plan-name">{p.package_name}</span>
                                            <div className="payment-plan-meta">
                                                <span className="payment-plan-tag">{p.duration} MONTH</span>
                                                <span className={`pay-type-badge ${p.payment_type}`}>{p.payment_type}</span>
                                            </div>
                                        </div>
                                        <div className="payment-card-total">
                                            <span className="payment-total-label">Total Paid</span>
                                            <span className="payment-total-amt">₹{parseFloat(p.total_amount).toLocaleString("en-IN")}</span>
                                        </div>
                                    </div>

                                    <div className="payment-breakdown">
                                        <div className="breakdown-row">
                                            <span className="breakdown-label">Package Price</span>
                                            <span className="breakdown-value">₹{parseFloat(p.package_price).toLocaleString("en-IN")}</span>
                                        </div>
                                        {parseFloat(p.admission_fee) > 0 && (
                                            <div className="breakdown-row">
                                                <span className="breakdown-label">Admission Fee</span>
                                                <span className="breakdown-value">₹{parseFloat(p.admission_fee).toLocaleString("en-IN")}</span>
                                            </div>
                                        )}
                                        <div className="breakdown-row breakdown-total-row">
                                            <span className="breakdown-label">Total Amount</span>
                                            <span className="breakdown-value breakdown-total">₹{parseFloat(p.total_amount).toLocaleString("en-IN")}</span>
                                        </div>
                                    </div>

                                    <div className="payment-card-footer">
                                        <span className="status-badge paid">Paid</span>
                                        <span className="payment-date-text">{p.date}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                );

            case "settings":
                return (
                    <div className="content-card">
                        <div className="card-header">
                            <span className="card-tag">PREFERENCES</span>
                            <h2>Settings</h2>
                        </div>
                        <div className="settings-list">
                            <div className="setting-row">
                                <div className="setting-info">
                                    <span className="setting-title">Email Notifications</span>
                                    <span className="setting-desc">Receive updates via email</span>
                                </div>
                                <label className="toggle">
                                    <input type="checkbox" defaultChecked />
                                    <span className="toggle-slider"></span>
                                </label>
                            </div>
                            <div className="setting-row">
                                <div className="setting-info">
                                    <span className="setting-title">SMS Notifications</span>
                                    <span className="setting-desc">Receive updates via SMS</span>
                                </div>
                                <label className="toggle">
                                    <input type="checkbox" />
                                    <span className="toggle-slider"></span>
                                </label>
                            </div>
                        </div>
                        <button className="save-btn">Save Settings</button>
                    </div>
                );

            default:
                return null;
        }
    };

    return (
        <div className="gym-dashboard">

            {/* SIDEBAR */}
            <div className="sidebar">
                <div className="sidebar-header" onClick={() => navigate("/")}>
                    <img src={logo} alt="logo" className="gym-logo" />
                    <div className="sidebar-brand">
                        <h2 className="sidebar-title">Burnout</h2>
                        <span className="sidebar-subtitle">GYM</span>
                    </div>
                </div>

                <div className="sidebar-divider" />

                <nav className="sidebar-nav">
                    <p className="nav-section-label">MENU</p>
                    <ul>
                        {navItems.map(({ key, label, icon }) => (
                            <li
                                key={key}
                                onClick={() => setActiveTab(key)}
                                className={activeTab === key ? "active" : ""}
                            >
                                <span className="nav-icon">{icon}</span>
                                <span className="nav-label">{label}</span>
                                {activeTab === key && <span className="nav-indicator" />}
                            </li>
                        ))}
                    </ul>
                </nav>

                <div className="sidebar-footer">
                    <div className="sidebar-user-mini">
                        <div className="avatar-ring">
                            <img src={logo} alt="profile" />
                        </div>
                        <div className="sidebar-user-info">
                            <span className="sidebar-user-name">{user?.full_name || "Member"}</span>
                            <span className="sidebar-user-plan">Premium</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="dashboard-content">

                {/* TOP BAR */}
                <div className="dashboard-topbar">
                    <div className="topbar-left">
                        <span className="topbar-breadcrumb">Dashboard</span>
                        <span className="topbar-sep">/</span>
                        <span className="topbar-page">{navItems.find(n => n.key === activeTab)?.label}</span>
                    </div>

                    <div className="profile-box">
                        <div className="topbar-avatar-wrap">
                            <img src={logo} alt="profile" className="profile-avatar" />
                            <span className="online-dot" />
                        </div>
                        <div className="profile-dropdown">
                            <button className="logout-btn" onClick={() => {
                                dispatch(logout());
                                navigate("/");
                                toast.success("Logged out successfully");
                            }}>
                                Logout
                            </button>
                        </div>
                    </div>
                </div>

                {/* MAIN BODY */}
                <div className="dashboard-body">
                    {renderContent()}
                </div>
            </div>
        </div>
    );
};

export default GymProfile;
